import { motion } from "motion/react";

interface TypingIndicatorProps {
  label?: string;
}

export function TypingIndicator({ label = "Thinking..." }: TypingIndicatorProps) {
  return (
    <div className="flex items-center gap-3 px-4 py-2 opacity-70">
      <div className="flex items-center gap-1">
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut", delay: 0 }}
          className="w-1.5 h-1.5 rounded-full bg-brand-400"
        />
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
          className="w-1.5 h-1.5 rounded-full bg-brand-400"
        />
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
          className="w-1.5 h-1.5 rounded-full bg-brand-400"
        />
      </div>
      {label && (
        <span className="text-xs font-medium text-text-tertiary italic animate-pulse">
          {label}
        </span>
      )}
    </div>
  );
}
